import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import numeral from 'numeral';

import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';

import BlankState from '../../../components/BlankState';
import StatusMessages from '../../../components/StatusMessages';

import { saveDiscount, listDiscounts } from '../../../actions/discounts';
import { fetchQuotes } from '../../../actions/policies';

import { getCurrentUser } from '../../../utils/user-utils';

class Discounts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      discount: {
        is_discount: true,
        discount_status: 'NOT_AVAILABLE',
        discount_approved: true,
        discount_type: ''
      },
      user: {
        ...this.props.user
      },
      submitted: false
    };
  }

  componentDidMount() {
    this.getDiscounts();
  }

  componentWillReceiveProps(nextProps) {
    const { quotes } = nextProps.policies;

    if (quotes.results.length > 0) {
      const {
        id,
        premium,
        gross_direct_premium,
        stamp_duty,
        insurance_training_levy,
        pcf
      } = quotes.results[0];

      this.setState({
        discount: {
          ...this.state.discount,
          id,
          premium,
          gross_direct_premium,
          stamp_duty,
          insurance_training_levy,
          pcf
        }
      });
    }
  }

  getDiscounts = () => {
    this.props.listDiscounts();
  };

  fetchPolicyInfo = e => {
    e.preventDefault();

    const order_number = this.refs.orderNumber.value;

    this.props.fetchQuotes({
      order_number
    });
  };

  onChange = e => {
    e.preventDefault();

    const { discount } = this.state;
    const { name, value } = e.target;
    const { userInfo } = this.state.user;

    this.setState({
      discount: {
        ...discount,
        [name]: value,
        authorized_by: userInfo.id,
        insurer: userInfo.insurer,
        quote: discount.id
      }
    });
  };

  onSubmitDiscount = e => {
    e.preventDefault();

    this.setState({ submitted: true });
    const { discount } = this.state;

    if (discount.hasOwnProperty('id')) {
      this.props.saveDiscount(discount).then(response => {
        this.props.listDiscounts();
      });
    } else {
      alert('Enter all required details');
    }
  };

  render() {
    const { user } = this.props;
    const currentUser = getCurrentUser(user);

    const menuItems = [
      { id: 'discounts', name: 'Discounts', active: true },
      currentUser.role === 'insurer_admin'
        ? { id: 'Create-discount', name: 'Create Discount' }
        : ''
    ];

    const { discount, submitted } = this.state;

    const { discounts, discounts_loading } = this.props.discounts;
    const { quotes, quotes_loading } = this.props.policies;

    const { total_sum_insured, total_cfr, premium, order_number } =
      quotes.results.length > 0 ? quotes.results[0] : {};

    return (
      <Page isAdminPage={true} pageTitle="Discounts">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              {discounts.length > 0 && !discounts_loading ? (
                <DataTable
                  tableId="discounts-table"
                  columnTitles={[
                    'Policy No.',
                    'Policy Holder',
                    'Premium',
                    'Sum Insured',
                    'Discount Amount',
                    'Discount Status'
                  ]}
                >
                  {discounts.map((discount, index) => {
                    const {
                      policy_number,
                      order_number,
                      proposer_name,
                      premium,
                      total_sum_insured,
                      discount_amount,
                      is_discount,
                      discount_status
                    } = discount;

                    if (is_discount) {
                      return (
                        <tr key={index}>
                          <td>
                            {policy_number} <br />
                            <small className="text-danger">
                              Order No. {order_number}
                            </small>
                          </td>
                          <td>{proposer_name}</td>
                          <td>{numeral(premium).format('0,0')}</td>
                          <td>{numeral(total_sum_insured).format('0,0')}</td>
                          <td>{numeral(discount_amount).format('0,0')}</td>
                          <td>
                            <span
                              className={
                                'label label-' +
                                (discount_status === 'ACCEPTED'
                                  ? 'success'
                                  : 'warning')
                              }
                            >
                              {discount_status}
                            </span>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={discounts}
                  dataName="Discounts"
                  isDataLoading={discounts_loading}
                />
              )}
            </Tab>

            <Tab menuId={menuItems[1].id}>
              <div className="col-md-6">
                <form
                  className="form form-horizontal"
                  onSubmit={this.fetchPolicyInfo}
                >
                  {discounts.errorCreateDiscount ? (
                    <StatusMessages
                      type="error"
                      message={discounts.errorMessageCreateDiscount}
                    />
                  ) : null}
                  {discounts.success ? (
                    <StatusMessages
                      type="success"
                      message={discounts.successMessage}
                    />
                  ) : null}

                  <div className="row">
                    <div className="col-sm-offset-4 col-sm-8">
                      <BlankState
                        data={false}
                        customMessage="Fetching policy details..."
                        isDataLoading={quotes_loading}
                      />

                      {quotes.results.length === 0 &&
                      quotes.hasOwnProperty('count') ? (
                        <StatusMessages
                          type="error"
                          message="Could not find the requested policy"
                        />
                      ) : null}
                    </div>
                  </div>

                  <div className="row">
                    <label className="control-label col-sm-4">
                      Search Policy
                    </label>

                    <div className="col-sm-8">
                      <div className="input-group no-border">
                        <input
                          type="text"
                          ref="orderNumber"
                          className="form-control"
                          required
                        />

                        <span className="input-group-btn">
                          <button className="btn btn-primary">
                            <i className="icon ion-search" /> Search
                          </button>
                        </span>
                      </div>
                      <div className="text-info">
                        Enter the Policy Order No.
                      </div>
                    </div>
                  </div>

                  <hr />
                </form>

                <form
                  className="form-horizontal"
                  noValidate
                  onSubmit={this.onSubmitDiscount}
                >
                  <div className="form-group">
                    <label className="col-sm-4 control-label">
                      Order Number:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="order_number"
                        className="form-control"
                        placeholder={order_number}
                        required
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 control-label">
                      Total Sum Insured:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="total_sum_insured"
                        className="form-control"
                        placeholder={
                          'TZS. ' + numeral(total_sum_insured).format('0,0') ||
                          ''
                        }
                        required
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 control-label">Total CFR:</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="total_cfr"
                        className="form-control"
                        placeholder={'TZS. ' + numeral(total_cfr).format('0,0')}
                        required
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 control-label">Premium:</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="premium"
                        className="form-control"
                        placeholder={'TZS. ' + numeral(premium).format('0,0')}
                        required
                        readOnly
                      />
                    </div>
                  </div>

                  <div
                    className={
                      'form-group' +
                      (submitted && !discount.discount_type ? ' has-error' : '')
                    }
                  >
                    <label className="col-sm-4 control-label">
                      Discount Type:
                    </label>
                    <div className="col-sm-8">
                      <select
                        name="discount_type"
                        onChange={this.onChange}
                        className="form-control"
                        required
                      >
                        <option value="">-- Select Discount Type</option>
                        <option value="PERCENTAGE">Percentage</option>
                        <option value="AMOUNT">Amount</option>
                      </select>
                      {submitted &&
                        !discount.discount_type && (
                          <div className="help-block">
                            Discount Type is Required
                          </div>
                        )}
                    </div>
                  </div>

                  {discount.discount_type !== '' ? (
                    <div className="clearfix">
                      {discount.discount_type === 'PERCENTAGE' ? (
                        <div
                          className={
                            'form-group ' +
                            (submitted && !discount.discount_percentage
                              ? ' has-error'
                              : '')
                          }
                        >
                          <label className="col-sm-4 control-label">
                            Discount Percentage:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              onChange={this.onChange}
                              name="discount_percentage"
                              className="form-control"
                              required
                            />
                            {submitted &&
                              !discount.discount_percentage && (
                                <div className="help-block">
                                  A valid number is Required
                                </div>
                              )}
                          </div>
                        </div>
                      ) : null}

                      {discount.discount_type === 'AMOUNT' ? (
                        <div
                          className={
                            'form-group' +
                            (submitted && !discount.discount_amount
                              ? ' has-error'
                              : '')
                          }
                        >
                          <label className="col-sm-4 control-label">
                            Discount Amount:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              onChange={this.onChange}
                              name="discount_amount"
                              className="form-control"
                              required
                            />
                            {submitted &&
                              !discount.discount_amount && (
                                <div className="help-block">
                                  A valid Number is Required
                                </div>
                              )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={
                      'form-group' +
                      (submitted && !discount.discount_reason
                        ? ' has-error'
                        : '')
                    }
                  >
                    <label className="col-sm-4 control-label">
                      Discount Reason:
                    </label>
                    <div className="col-sm-8">
                      <textarea
                        onChange={this.onChange}
                        name="discount_reason"
                        className="form-control"
                      />
                      {submitted &&
                        !discount.discount_reason && (
                          <div className="help-block">A reason is Required</div>
                        )}
                    </div>
                  </div>

                  <div type="submit" className="col-sm-offset-4 col-sm-8">
                    <button className="btn btn-success">
                      <i className="icon ion-checkmark" /> Apply Discount
                    </button>
                  </div>
                </form>
              </div>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  discounts: state.discounts,
  policies: state.policies
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { listDiscounts, saveDiscount, fetchQuotes },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Discounts);



// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/Discounts.jsx